module.exports = __webpack_public_path__ + "static/img/ced74993f7b411fd3323b2ceb0f520e.5e3868d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ced74993f7b411fd3323b2ceb0f520e.png
// module id = VH2C
// module chunks = 1